import * as React from 'react';
import {Logo} from './logo';
import {fontHeading} from '../theme/font';
import {px} from 'csx';
import {style} from 'typestyle';
import {colorSlate, colorWhite} from '../theme/color';

export interface HookdDefinitionProps {
  className?: string;
  i18n?: {}
  light?: boolean;
}

const DEFAULT_I18N = {};

export const HookdDefinition: React.SFC<HookdDefinitionProps> = ({ className, i18n = DEFAULT_I18N, light = false }) => (
  <div style={{color:light ? colorWhite.toString() : colorSlate.toString()}} className={styles.container}>
    <div>Definition</div>
    <div><Logo color={light ? colorWhite : colorSlate} width={130}/></div>
    <div><span>Lickd</span> /lɪkt/ verb. License [authorise the use of] a song for uploaded video content on the internet.</div>
    <div>“Having Lickd the track for their latest video on YouTube, they could now avoid copyright infringement claims and keep the revenue from their content”</div>
  </div>
);


const styles = {
  container: style({
    padding: px(20),
    maxWidth: px(500),
    color: 'red',
    $nest: {
      '&> div:nth-child(1)': {
        fontFamily: fontHeading,
        fontSize: px(18),
        lineHeight: px(46)
      },
      '&> div:nth-child(2)': {
        padding: '0 0 0 1px'
      },
      '&> div:nth-child(3)': {
        margin: '10px 0',
        fontSize: px(20),
        lineHeight: px(31),
        fontWeight: 400,
      },
      '&> div:nth-child(3) span': {
        fontWeight: 600
      },
      '&> div:nth-child(4)': {
        fontStyle: 'italic',
        fontSize: px(14),
        lineHeight: px(21)
      },
    }
  })
};